var invoiceMap = {
  id: 'id',
  userId: 'userId',
  from: 'from',
  until: 'until',
  files: 'files',
  dateCreated: 'dateCreated',
  notes: 'notes'
};
export default invoiceMap;